import * as React from 'react'
import Layout from '../../components/layout'
import { PageProps } from 'gatsby';
import Seo from '../../components/seo';
import Dinner from '../../components/dinner';


const DinnerPage: React.FC<PageProps> = (props) => {
    return (
      <Layout title="Dinner">
        <Dinner />
      </Layout>
    );
}

export const Head = () => <Seo title="Make a donation" />

export default DinnerPage;